import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { AnimatePresence } from 'framer-motion';
import dynamic from 'next/dynamic';
import { useRouter } from 'next/router';
import { useGate } from 'statsig-react';
import { faBars } from '@soundxyz/font-awesome/pro-solid-svg-icons/index.mjs';
import { styled } from '@components-shared/src/stitches';
import { SoundLogo } from '@components/icons/SoundLogo';
import { HIDDEN_FEATURE_BANNER_ROUTES } from '@components/layout';
import { AccessibleLink } from '@components/main-components/link/AccessibleLink';
import { useHeaderStore } from '@store/header';
import { FEATURE_GATES } from '@utils/constants';
import { iconVariants, SubContainer } from '../styles';
import type { StrokeColor } from '../types';

const DynamicFeedBanner = dynamic(
  () => import('@components/Header/Banner/NewFeedFeature').then(mod => mod.NewFeedFeatureBanner),
  {
    ssr: false,
  },
);

export const MobileHeader = ({ strokeColor }: { strokeColor: StrokeColor }) => {
  const { open } = useHeaderStore();
  const { pathname } = useRouter();
  const { value: openPostsEnabled } = useGate(FEATURE_GATES.OPEN_POSTS);
  const showNewFeatureBanner = !HIDDEN_FEATURE_BANNER_ROUTES.some(route =>
    pathname.includes(route.path),
  );

  const openHamburger = () => open('hamburger');
  return (
    <div className="flex w-full flex-col">
      {showNewFeatureBanner && openPostsEnabled && (
        <AnimatePresence>
          <div className="-mx-4 -mt-4 mb-4 block  md:hidden">
            <DynamicFeedBanner />
          </div>
        </AnimatePresence>
      )}

      <div className="flex h-full w-full">
        <SubContainer>
          <AccessibleLink pathnameUri="/">
            <SoundLogo color={strokeColor} />
          </AccessibleLink>
        </SubContainer>
        <div className="relative ml-3 flex h-10 w-fit  items-center justify-end gap-3 md:px-0">
          <div className="flex gap-x-5">
            <div
              className="relative flex h-5 cursor-pointer items-center px-0"
              onClick={openHamburger}
            >
              <IconContainer stroke={strokeColor}>
                <FontAwesomeIcon icon={faBars} size="lg" />
              </IconContainer>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

const IconContainer = styled('div', {
  ...iconVariants,
});
